import Link from 'next/link';

import Container from 'components/container';

import {
  BLOCK_URL,
  DON_GITHUB,
  DON_LINKEDIN,
  DON_MAILTO,
  DYLAN_GITHUB,
  DYLAN_ICHTHUS,
  DYLAN_LINKEDIN,
  DYLAN_MAILTO,
  JH_VENDORS_URL,
  LIBUM_URL,
  MICROSOFT_URL,
  NORTHROP_GRUMMAN_URL,
  ROKU_URL,
  SANDIA_NATIONAL_LABS_URL,
  UNIVERSITY_OF_HOUSTON_URL,
  UNIVERSITY_OF_MICHIGAN_URL,
} from 'shared/constants/globals';
import {
  AboutContainer,
  AboutDivider,
  AboutFounder,
  AboutFounderDescription,
  AboutFounderSocials,
  AboutFoundersWrapper,
} from './about.styles';

import EMAIL_ICON from 'public/icons/eva/email.svg';
import GITHUB_ICON from 'public/icons/icons8/github.svg';
import ICHTHUS_ICON from 'public/icons/icons8/ichthus.svg';
import LINKED_IN_ICON from 'public/icons/icons8/linkedin.svg';

export default function About() {
  const title = 'About | Libum';
  const description =
    'Learn about the Libum team and the mission to bring the software the community wants to the credit union space.';
  const keywords =
    'Libum,Don Nguyen,Dylan Martinez,NexumAPI,PowerOn Pro,Glaci,Symitar developers,PowerOn developers,Jack Henry VIP members,Jack Henry software,credit union software';
  const url = `${LIBUM_URL}/about`;

  return (
    <Container title={title} description={description} keywords={keywords} url={url} socialCard="about">
      <div style={{ width: '100%' }}>
        <AboutContainer>
          <div>
            <p id="mission">
              Founded in 2020 with the goal of building software that enables credit unions to better serve their
              members.
            </p>
            <AboutDivider />
            <p id="overview">
              We started back in 2016 when founders Don Nguyen and Dylan Martinez were placed as the first internal devs
              of a $1B+ credit union in Houston, TX. They pushed the limits of integration and created many applications
              designed to augment the employee experience when servicing members. Eventually, new requests were referred
              to as a &quot;piece of cake&quot; which inspired the name &quot;Libum&quot;.
            </p>
            <AboutDivider />
            <AboutFoundersWrapper id="founders">
              <AboutFounder>
                {/* eslint-disable-next-line */}
                <img src="/images/bf5a1a72-be39-4f19-b052-86d1de4b646b.png" alt="Don Nguyen, one of the co-founders of Libum" />
                <h3>Don Nguyen</h3>
                <h4>Co-Founder & Security/Software Engineer</h4>
                <AboutFounderSocials>
                  <Link href={DON_MAILTO}>
                    <EMAIL_ICON className="email" />
                  </Link>
                  <Link href={DON_GITHUB} target="_blank">
                    <GITHUB_ICON />
                  </Link>
                  <Link href={DON_LINKEDIN} target="_blank">
                    <LINKED_IN_ICON />
                  </Link>
                </AboutFounderSocials>
                <AboutFounderDescription>
                  Don has experience building secure systems in the tech industry at places like{' '}
                  <Link href={BLOCK_URL} target="_blank" className="text">
                    Block
                  </Link>
                  ,{' '}
                  <Link href={ROKU_URL} target="_blank" className="text">
                    Roku
                  </Link>
                  , and{' '}
                  <Link href={SANDIA_NATIONAL_LABS_URL} target="_blank" className="text">
                    Sandia Labs
                  </Link>
                  . His life in the credit union world began as a teller and operations where he eventually moved up the
                  ladder to become a Software Developer, pushing the boundaries of what was previously considered
                  possible. He has a BS and MS in Computer Engineering from the{' '}
                  <Link href={UNIVERSITY_OF_MICHIGAN_URL} target="_blank" className="text">
                    University of Michigan
                  </Link>{' '}
                  and{' '}
                  <Link href={UNIVERSITY_OF_HOUSTON_URL} target="_blank" className="text">
                    Houston
                  </Link>
                  .
                </AboutFounderDescription>
              </AboutFounder>
              <AboutFounder>
                {/* eslint-disable-next-line */}
                <img className="ichthus" src="/images/dacb68c0-0e34-43b7-8cb2-53150c96d438.png" alt="Dylan Martinez, one of the co-founders of Libum" />
                <h3>Dylan Martinez</h3>
                <h4>Co-Founder & Security/Software Engineer</h4>
                <AboutFounderSocials>
                  <Link href={DYLAN_MAILTO}>
                    <EMAIL_ICON className="email" />
                  </Link>
                  <Link href={DYLAN_GITHUB} target="_blank">
                    <GITHUB_ICON />
                  </Link>
                  <Link href={DYLAN_LINKEDIN} target="_blank">
                    <LINKED_IN_ICON />
                  </Link>
                  <Link href={DYLAN_ICHTHUS} target="_blank">
                    <ICHTHUS_ICON className="ichthus" />
                  </Link>
                </AboutFounderSocials>
                <AboutFounderDescription>
                  Dylan has over ten years of credit union experience designing and developing innovative solutions that
                  have consistently created new norms. He is currently working on secure cloud at{' '}
                  <Link href={MICROSOFT_URL} target="_blank" className="text">
                    Microsoft
                  </Link>{' '}
                  and previously worked on flight software at{' '}
                  <Link href={NORTHROP_GRUMMAN_URL} target="_blank" className="text">
                    Northrop Grumman
                  </Link>
                  . Before that, he studied Physics in{' '}
                  <Link href={UNIVERSITY_OF_HOUSTON_URL} target="_blank" className="text">
                    Houston, TX
                  </Link>{' '}
                  and has a Masters in Space Engineering from the{' '}
                  <Link href={UNIVERSITY_OF_MICHIGAN_URL} target="_blank" className="text">
                    University of Michigan
                  </Link>
                  .
                </AboutFounderDescription>
              </AboutFounder>
            </AboutFoundersWrapper>
            <AboutDivider />
            <p>
              In 2022, we released <Link href="/nexum">NexumAPI</Link>; the quickest way to use SymXchange. In 2024, we
              built <Link href="/poweron-pro">PowerOn Pro</Link>, a VS Code extension that hundreds of developers prefer
              to write their PowerOn code. Now, we are in the midst of releasing <Link href="/glaci">Glaci</Link>, an
              overlay for Symitar Quest that will unlock a new frontier for credit union operations.
            </p>
            <AboutDivider />
            <p style={{ marginBottom: '56px' }}>
              Libum has been an official member of the Jack Henry{' '}
              <Link href={JH_VENDORS_URL}>Vendor Integration Program (VIP)</Link> since 2020.
            </p>
          </div>
        </AboutContainer>
      </div>
    </Container>
  );
}
